<template>
	<div class="report-list">
		<CFullEmpty v-if="emptyData" class="empty-box" />
		<template v-else>
			<div v-for="(item, index) in tabData" :key="index" class="report-box" @click="jumpToNotice(item)">
				<div class="report-tip">
					<img class="icon-svg" src="@/assets/images/irstore/icon-gonggao.svg" alt="" />
					<span class="tip-content">{{ $t('enterprise.announcement') }}</span>
					<span class="date font-Regular">{{ item.publishDate }}</span>
				</div>
				<div class="report-title">{{ item.title }}</div>
			</div>
		</template>
		<CFooterLoad ref="footerLoadObs" :more="hasMore" @load-more="loadMoreData" />
	</div>
</template>

<script>
import { irstore } from '@/fetch/interface';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import CFooterLoad from '@/view/enterprise/components/c-footer-load.vue';
import CFullEmpty from '@/view/enterprise/components/c-full-empty.vue';
import paginationMixin from '@/view/enterprise/mixins/paginationMixin';
import { getLanguageType } from '@/assets/js/i18n';
import { useCommonData } from '@rebuild/hooks/useCommonData';

export default {
	components: {
		CFooterLoad,
		CFullEmpty
	},
	mixins: [paginationMixin],
	props: {
		storeData: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	data() {
		return {};
	},
	mounted() {
		// install mixins
		this.PAGINATION_LOAD = this.loadModule;
		this.PAGINATION_OBS_INSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.install();
		};
		this.PAGINATION_OBS_UNINSTALL = () => {
			this.$refs.footerLoadObs && this.$refs.footerLoadObs.uninstall();
		};
	},
	methods: {
		loadMoreData() {
			this.PAGINATION_LOAD_MORE();
		},
		refreshModule(query) {
			if (!query.actionFilter.length) {
				return (this.emptyData = true);
			}
			this.PAGINATION_REFRESH(query);
		},
		loadModule() {
			const { id } = this.storeData;
			const tabId = this.queryOptions.value ? this.queryOptions.value : '';
			let params = {
				pageStart: this.pageStart,
				pageNum: 20,
				classificationIds: tabId,
				searchFrom: 'customTab',
				isPublish: true,
				languageType: getLanguageType()
			};

			// 皓元医药定制化，ESG特殊处理
			if (this.isChemExpress && tabId === 'ESG') {
				params.classificationIds = '';
				params.title = 'ESG';
			}
			return this.$axios
				.get(irstore.getAnnouncements(id), params)
				.then(res => {
					const result = (res?.data || []).map((item, i) => {
						item.annoTitle = item.title;
						return item;
					});
					this.PAGINATION_DATA_UPDATE(result);
					this.$emit('refresh');

					const total = res?.total || 0;
					const hasMore = this.tabData.length < total;
					return Promise.resolve(hasMore);
				})
				.catch(() => Promise.resolve(false));
		},
		jumpToNotice(item) {
			this.viewModule('announcement', item);
		}
	},
	setup() {
		const { viewModule } = useModuleNavigation();
		const { isChemExpress } = useCommonData();
		return {
			viewModule,
			isChemExpress
		};
	}
};
</script>

<style lang="less" scoped>
.report-list {
	background: #f7f7f7;

	.empty-box {
		padding: 0.2rem 0;
	}

	.fiter-wrap {
		li {
			width: auto;
			padding: 0 0.1rem;
		}
	}
	.report-box {
		padding: 0.12rem;
		background: #fff;

		& + .report-box {
			margin-top: 0.08rem;
		}
		.report-tip {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 0.12rem;
			line-height: 0.17rem;
			color: #333;
			.icon-svg {
				width: 0.16rem;
				height: 0.16rem;
			}
			.tip-content {
				margin-left: 0.08rem;
			}
			.date {
				margin-left: 0.08rem;
				font-size: 0.11rem;
				line-height: 0.15rem;
				color: #666;
			}
		}
		.report-title {
			margin: 0.1rem 0 0;
			font-size: 0.15rem;
			line-height: 0.24rem;
			letter-spacing: 1px;
			color: #333;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}
	}
}
</style>
